import { createSelector } from 'reselect';
import path from 'ramda/es/path';
import pipe from 'ramda/es/pipe';
import values from 'ramda/es/values';
import find from 'ramda/es/find';


const createOptionSubSelector = () => createSelector(
  [
    (_, { tariff }) => tariff,
    state => state.apps.subs,
    state => state.apps.data,
    (_, { studentId }) => studentId,
    (_, { locked }) => locked,
  ],
  ({ id, service }, subs, data, studentId, locked) => (!locked
    ? pipe(
      values,
      find(({ tariff_id: targetTariffId, id: subId }) => (
        targetTariffId === id && path([service, studentId], data) === subId
      ))
    )(subs)
    : null
  )
);

export default createOptionSubSelector;
